import { getAuthProviderButtonsToShow } from "../../../gui/utils.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { UserRole } from "../../../login/UserRole.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { EvaluatedAction, EvaluatedActionType } from "../../EvaluatedAction.js";

/**
 * this is the reviewed version of login proposal behaviour please refer to #10999 - https://op.mgmtcp.com/issues/10999
 * this proposal does not consider one tap at all
 * @param sdk 
 * @param _logger 
 * @returns 
 */
export function evaluateLoginProposalReviewed(sdk: ClientSdkPublicInterface, _logger: Logger): Promise<EvaluatedAction<any>|null> {
    const session = sdk.getCurrentSession();
    if(session && session.role == UserRole.AUTHENTICATED_USER) {
        return Promise.resolve(null);
    }
    else {
        return getAuthProviderButtonsToShow(sdk, true).then(
            rawList => {
                const cfg = sdk.getConfig().loginManager;
                const list = rawList.filter(prov => !cfg.excludeFromCta || !cfg.excludeFromCta[prov]);
                if (list.length > 0) {
                    return {
                        data: {
                            onDemand: true,
                            providerId: list
                        },
                        type: EvaluatedActionType.SUBMIT_LOGIN
                    };
                }
                else {
                    return null;
                }
            }
        );
        
    }
                
}